module.exports = "<div class=\"notify-wrapper\" *ngIf=\"notifications.length\">\n  <div  class=\"alert\" [ngClass]=\"note.styleClass\" role=\"alert\" *ngFor=\"let note of notifications; let i = index;\">\n    <h4 *ngIf=\"note.heading\" class=\"alert-heading\">{{note.heading}}</h4>\n    <p>{{note.body}}</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notify/notify.component.html
// module id = 474
// module chunks = 0